import BigNumber from "bignumber.js";

export const FARMS_SMALL_AMOUNT_THRESHOLD = new BigNumber(0.00001);
